import WebGLManager from '~/glxp/webglManager'
import RAF from '~/glxp/utils/raf.js'

export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.provide('webglManager', WebGLManager)
  nuxtApp.provide('raf', RAF)
})
